/** Build-time config. Bun inlines `process.env.BUN_PUBLIC_*` into the browser
 * bundle (see `env: "BUN_PUBLIC_*"` in build.ts and bunfig.toml), so a deploy
 * can override either value without touching source.
 *
 * The fallbacks are the live values rather than empty strings, because the
 * bundle has to carry a working token for uploads to authenticate at all —
 * a build that forgets the env var otherwise ships an app that 401s on every
 * upload and pauses the queue. Anyone who can load the app can read this
 * token; that is inherent to a browser client, not a property of writing it
 * down here. */
export const SERVER_URL = buildEnv(() => process.env.BUN_PUBLIC_SERVER_URL) || "https://scanner.nyntax.com";
export const API_TOKEN =
  buildEnv(() => process.env.BUN_PUBLIC_API_TOKEN) ||
  "15ce7da4b0f6cfb5ad5efc3052876c9c2447bc06888aab410c4fe3de2a205c44";

/** Reads one inlined build variable. Bun substitutes a literal
 * `process.env.BUN_PUBLIC_X` only for variables that were actually set when
 * the bundle was built — every other one is left in the output verbatim, and
 * `process` does not exist in a browser. Evaluating it therefore threw
 * `ReferenceError: process is not defined` at module load, before a single
 * component rendered: `bun dev` and any build run without the env vars served
 * a blank page instead of falling back to the defaults above, which is the
 * one case the defaults exist for. The closure keeps the literal intact for
 * the inliner while confining that throw to a value of `undefined`. */
export function buildEnv(read: () => string | undefined): string | undefined {
  try {
    return read();
  } catch {
    return undefined;
  }
}

const KEY_SCANNER_NAME = "scannerName";
const KEY_REVIEWER_NAME = "reviewerName";
const KEY_DEVICE_ID = "deviceId";
const KEY_FLUSH_HANDLED_AT = "flushHandledAt";

export const settings = {
  getScannerName: () => localStorage.getItem(KEY_SCANNER_NAME),
  setScannerName: (name: string) => localStorage.setItem(KEY_SCANNER_NAME, name),
  getReviewerName: () => localStorage.getItem(KEY_REVIEWER_NAME),
  setReviewerName: (name: string) => localStorage.setItem(KEY_REVIEWER_NAME, name),

  /** Stable id for this browser profile, minted on first use. The scanner
   * name can't do this job: two phones are often named after the same
   * person's role, and the desk needs to tell one device's backlog from
   * another's. */
  getDeviceId: () => {
    const existing = localStorage.getItem(KEY_DEVICE_ID);
    if (existing) return existing;
    const id = crypto.randomUUID();
    localStorage.setItem(KEY_DEVICE_ID, id);
    return id;
  },

  /** The newest desk-issued flush this device has already acted on. Stored
   * rather than held in memory so a reload doesn't re-run a flush that was
   * handled an hour ago. */
  getFlushHandledAt: () => localStorage.getItem(KEY_FLUSH_HANDLED_AT),
  setFlushHandledAt: (at: string) => localStorage.setItem(KEY_FLUSH_HANDLED_AT, at),
};
